import React, { useContext, useEffect, useMemo, useRef } from "react";
import { FiArrowRight, FiCheck, FiMail, FiPackage, FiX } from "react-icons/fi";
import { Link, useSearchParams } from "react-router-dom";
import { formatPrice, siteConfig } from "../Datas/productData";
import { CartContext } from "./CartContext";
import "../css/paysuccess.css";

const readPendingOrder = () => {
  try {
    return JSON.parse(window.localStorage.getItem("poodlivingPendingOrder")) || {};
  } catch {
    return {};
  }
};

const PaySuccess = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const cartCleared = useRef(false);
  const state = searchParams.get("state") === "success" ? "success" : "cancel";
  const pendingOrder = useMemo(readPendingOrder, []);
  const orderTotal = Number.isFinite(Number(pendingOrder.total)) ? formatPrice(pendingOrder.total) : null;

  useEffect(() => {
    if (state === "success" && !cartCleared.current) {
      cartCleared.current = true;
      clearCart();
    }
  }, [state, clearCart]);

  if (state === "cancel") {
    return (
      <main className="payment-success payment-success--cancel">
        <section className="payment-success__card" aria-labelledby="cancel-heading">
          <div className="payment-success__mark" aria-hidden="true"><FiX /></div>
          <p className="payment-success__eyebrow">Payment not completed</p>
          <h1 id="cancel-heading">Your order is still in the cart</h1>
          <p className="payment-success__intro">
            The payment was cancelled or could not be completed. Nothing has been confirmed, and you can return to checkout to try again.
          </p>
          <div className="payment-success__next">
            <p><FiPackage /> Your selected items remain available in your cart.</p>
            <p><FiMail /> Need help? Email {siteConfig.contact.email}.</p>
          </div>
          <div className="payment-success__actions">
            <Link to="/checkout">Return to checkout <FiArrowRight /></Link>
            <Link to="/contact">Contact support</Link>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="payment-success">
      <section className="payment-success__card" aria-labelledby="success-heading">
        <div className="payment-success__mark" aria-hidden="true"><FiCheck /></div>
        <p className="payment-success__eyebrow">Payment successful</p>
        <h1 id="success-heading">Thank you for your order</h1>
        <p className="payment-success__intro">
          Your payment has been completed and your {siteConfig.brandName} order is now being prepared.
        </p>
        <dl className="payment-success__details">
          {pendingOrder.orderNo && <div><dt>Order number</dt><dd>{pendingOrder.orderNo}</dd></div>}
          {orderTotal && <div><dt>Order total</dt><dd>{orderTotal}</dd></div>}
          <div><dt>Status</dt><dd>Preparing your order</dd></div>
        </dl>
        <div className="payment-success__next">
          <p><FiMail /> Order updates will be sent to {pendingOrder.email || "your checkout email"}.</p>
          <p><FiPackage /> Tracked delivery timing begins after dispatch.</p>
        </div>
        <div className="payment-success__actions">
          <Link to="/shop">Continue shopping <FiArrowRight /></Link>
          <Link to="/contact">Need help?</Link>
        </div>
      </section>
    </main>
  );
};

export default PaySuccess;
